import { motion } from "framer-motion";
import { Sparkles, GraduationCap, Stamp, PenTool, Brain, Building } from "lucide-react";

const CREW = [
  { role: "Ex Graduate Committee Members", desc: "From Stanford, MIT, Oxford, UCL — they know what admit panels actually look for.", icon: GraduationCap },
  { role: "Ex Embassy Advisors",            desc: "Decoded visa interviews from inside the system. Know every flag.",                  icon: Stamp },
  { role: "Top Editorial Writers",          desc: "Crafting SOPs, LORs & essays that don't read like everyone else's.",                icon: PenTool },
  { role: "AI Research Engineers",          desc: "Ranking algorithms, profile-fit models, application tracking — built in-house.",   icon: Brain },
  { role: "Domain Subject Experts",         desc: "PhDs in CS, engineering, finance, design — they speak your future field fluently.", icon: Building },
];

export default function CrewSection() {
  return (
    <section className="py-16 md:py-24 bg-white border-b-[3px] border-[#282829]" data-testid="crew-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <span className="inline-block bg-[#c92e34] text-white text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full border-2 border-[#282829] -rotate-2">
              <Sparkles size={12} className="inline mr-1" /> Behind the Brand
            </span>
            <h2 className="font-display text-5xl md:text-7xl mt-3 leading-[0.9]" data-testid="crew-heading">
              Crew behind<br />the <span className="font-handwritten text-[#c92e34] inline-block -rotate-2">brew</span>.
            </h2>
            <p className="mt-5 text-[#282829]/70 leading-relaxed text-base md:text-lg">
              We are a team of artists who make sh*t happen. Founder-led, multi-disciplinary, ruthless about outcomes.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-3 md:gap-4">
            {CREW.map((c, i) => {
              const Icon = c.icon;
              return (
                <motion.div
                  key={c.role}
                  initial={{ opacity: 0, y: 18, rotate: i % 2 ? 1 : -1 }}
                  whileInView={{ opacity: 1, y: 0, rotate: i % 2 ? 1 : -1 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ delay: i * 0.06, type: "spring", stiffness: 80 }}
                  whileHover={{ y: -4, rotate: i % 2 ? 2 : -2 }}
                  className={`relative overflow-hidden rounded-2xl border-2 border-[#282829] p-5 ${
                    i % 2 ? "bg-[#282829] text-white brutal-shadow-red-sm" : "bg-[#c92e34] text-white brutal-shadow-ink"
                  }`}
                  data-testid={`crew-card-${i}`}
                >
                  <div className="w-11 h-11 rounded-xl bg-white text-[#c92e34] grid place-items-center border-2 border-white">
                    <Icon size={20} strokeWidth={2.5} />
                  </div>
                  <div className="font-display text-2xl md:text-3xl mt-3 leading-tight">{c.role}</div>
                  <p className="text-xs md:text-sm mt-2 opacity-85 leading-snug">{c.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
